<template>
	<div
		class="k__input"
		:class="{
			'k__input--focus': focus,
			'k__input--hasValue': hasValue,
			'k__input__textarea': textarea,
		}"
		ref="$container"
	>
		<slot></slot>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

defineProps({
	textarea: {
		type: Boolean,
		default: false,
	}
})

// REF
const $container = ref(null)
const $input     = ref(null)

// DATA
const focus = ref(false)
const hasValue = ref(false)

// Methods

// HOOKS
onMounted(() => {
	$input.value = $container.value.querySelector('.form-control');

	$input.value.addEventListener('focus', () => focus.value = true)
	$input.value.addEventListener('blur', () =>  {
		focus.value = false
		hasValue.value = $input.value.value != ''
	})
})
</script>

<style lang="scss">
.k__input{
	--k__input-border-width: 2px;
	--k__input-border-color: #CCC;

	--k__input-focus-border-color: #86b7fe;
	--k__input-focus-glow: rgba(13,110,253,.25);

	position: relative;
	perspective: 3px;
	padding-top: 52px;

	transition: filter .3s linear;

	&.k__input__textarea {
		padding-top: 89px;
	}

	&::before{
		content: '';
		position: absolute;
		left: 0;
		top: 0;

		width: 100%;
		height: 100%;

		background: var(--k__input-border-color);
		clip-path: polygon(
			0 0, 100% 0, 100% calc(100% - 20px), calc(100% - 18px) 100%, 0 100%
		);
		z-index: -2;
	}

	&--focus {
		filter: drop-shadow(0 0 .25rem var(--k__input-focus-glow));

		&::before{
			background: var(--k__input-focus-border-color);
		}
	}
}

.k__input .form-control {
	position: absolute;
	left: 0;
	top: 0;
	z-index: 0;

	width: 100%;
	height: 100%;
	border-radius: 0;

	clip-path: polygon(
		var(--k__input-border-width) var(--k__input-border-width),
		calc(100% - var(--k__input-border-width)) var(--k__input-border-width),
		calc(100% - var(--k__input-border-width)) calc(100% - 20px - var(--k__input-border-width)),
		calc(100% - 18px - var(--k__input-border-width)) calc(100% - var(--k__input-border-width)),
		var(--k__input-border-width) calc(100% - var(--k__input-border-width))
	);
}
</style>
